import { render, staticRenderFns } from "./Intimacao.vue?vue&type=template&id=f2d58ee8"
import script from "./Intimacao.vue?vue&type=script&lang=js"
export * from "./Intimacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports